import React from "react";
import { Table, Header } from "semantic-ui-react";
import PartyAllListItem from "./PartyAllListItem";

// Shared "section" table used by the All Transactions list and the Dashboard
// drill-down. Sorting is only wired up when `onSort` is passed - the
// dashboard drill-down renders a plain, already-sorted list.
export default function PartyTransactionsTable({
  transactions,
  title,
  showClosingDate = false,
  showNeedsSignatures = true,
  column,
  direction,
  onSort,
}) {
  if (!transactions || transactions.length === 0) return null;
  const sortable = typeof onSort === "function";

  return (
    <div className="medium bottom margin">
      <Header size="medium" color="blue" className="small bottom margin">
        {title}
      </Header>
      <Table compact sortable={sortable} className="mini top margin">
        <Table.Header className="mobile hidden">
          <Table.Row className="small-header">
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortable && column === "address" ? direction : null}
              onClick={sortable ? () => onSort("address") : undefined}
            >
              Address
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={
                sortable && column === "agentRepresents" ? direction : null
              }
              onClick={sortable ? () => onSort("agentRepresents") : undefined}
            >
              Side
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={
                sortable && column === "agentFirstName" ? direction : null
              }
              onClick={sortable ? () => onSort("agentFirstName") : undefined}
            >
              Agent First Name
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={
                sortable && column === "agentLastName" ? direction : null
              }
              onClick={sortable ? () => onSort("agentLastName") : undefined}
            >
              Agent Last Name
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortable && column === "updatedAt" ? direction : null}
              onClick={sortable ? () => onSort("updatedAt") : undefined}
            >
              Last Updated
            </Table.HeaderCell>
            {showClosingDate && (
              <Table.HeaderCell
                sorted={
                  sortable && column === "closingDateTime" ? direction : null
                }
                onClick={
                  sortable ? () => onSort("closingDateTime") : undefined
                }
              >
                Closing Date
              </Table.HeaderCell>
            )}
            {showNeedsSignatures && (
              <Table.HeaderCell
                sorted={
                  sortable && column === "needsSignatures" ? direction : null
                }
                onClick={
                  sortable ? () => onSort("needsSignatures") : undefined
                }
              >
                Needs Signatures
              </Table.HeaderCell>
            )}
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {transactions.map((party) => (
            <PartyAllListItem
              party={party}
              key={party.id}
              showClosingDate={showClosingDate}
              showNeedsSignatures={showNeedsSignatures}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
}
